
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.511.025l-2.458 1.23V7.56a2.858 2.858 0 00-1.478-.403c-1.357 0-2.458.88-2.458 1.968 0 1.087 1.1 1.967 2.458 1.967 1.36 0 2.46-.88 2.46-1.967V3.222l1.476-.738V.024z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    